import { apiWithkey } from "../axios";
import { baseApiURL, saveLeadApi } from "../endpoints";
import {
  setLoadingMessage,
  removeLoadingMessage,
} from "../../utils/setLoadingMessage";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useUserStore from "../../storeModules/useUserStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import { tagLeadSave } from "../../utils/sendTag";
import sleepAwait from "../../utils/sleepAwait";
import findStep from "../../screens/bot/stepModules/findStep";
import sha256 from "crypto-js/sha256";
import addPhoneDatalayerMask from "../../utils/addPhoneDatalayerMask";
import DatadogErrorReporter from "../../utils/datadogErrorReporter";
import GetLeadError from "../../utils/customErrors/getLeadError";
import {
  convertPhoneToPayload,
  convertPhoneToGTM,
  convertPhoneToHash,
} from "../../utils/convertPhone";

const fakeLoad = useInitialConfigStore.getState().fakeLoad;

const getLead = async () => {
  setLoadingMessage();

  const url = `${baseApiURL}${saveLeadApi}`;

  const { campanhaId, compraId, empresaId, categoriaId, tipo, referralcode } =
    useInitialConfigStore.getState();

  const { nome, email, telefone, rendaMensal } = useUserStore.getState().basic;

  const props = {
    nome,
    email,
    telefone: convertPhoneToPayload(telefone),
    rendaMensal,
    campanhaId,
    compraId,
    categoriaId,
    tipo,
    empresaId,
    referralCode: referralcode,
  };

  apiWithkey
    .post(url, props)
    .then(async (response) => {
      const { data, status } = response.data;
      if (DatadogErrorReporter.isErrorCode(status)) {
        DatadogErrorReporter.reportApiError(
          new GetLeadError(response.data, url, props),
        );
      }

      useUserStore.setState({
        lead: {
          LeadID: data.id,
          LeadToken: data.LeadToken,
        },
      });
      localStorage.setItem("mycon_lead_id", data.id);

      await sleepAwait(fakeLoad);
      removeLoadingMessage();

      const userNome = useUserStore.getState().basic.nome;
      const userEmail = useUserStore.getState().basic.email;
      const userTelefone = useUserStore.getState().basic.telefone;
      const userLeadID = useUserStore.getState().lead.LeadID;

      const hashedEmail = sha256(userEmail).toString();
      const hashedTelefone = convertPhoneToHash(userTelefone);

      tagLeadSave(
        hashedEmail,
        hashedTelefone,
        userEmail,
        userNome,
        convertPhoneToGTM(userTelefone),
        userLeadID,
      );

      useBotControlStore.setState({
        currentStep: findStep("carrega_planos").index,
      });

      return response;
    })
    .catch((error) => {
      DatadogErrorReporter.reportApiError(new GetLeadError(error, url, props));

      useBotControlStore.setState({
        currentStep: findStep("erro_geral").index,
      });

      removeLoadingMessage();
    });
};

export { getLead };
